// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3yNxR","label":"SetPasswdForm_label__TR74j"};